'use client';

import { type Rating, type ReviewResponse } from '@/helper/etrusted';
import React, { createContext, useContext } from 'react';

export interface ETrustedData {
  review: ReviewResponse | null;
  rating: Rating | null;
}

// Create the context with a default value of null
const ETrustedReviewsContext = createContext<ETrustedData | null>(null);

// Define the ETrustedReviewProvider as a functional component
const ETrustedReviewProvider: React.FC<{
  value: ETrustedData | null;
  children: React.ReactNode;
}> = ({ value, children }) => {
  return <ETrustedReviewsContext.Provider value={value}>{children}</ETrustedReviewsContext.Provider>;
};

// Custom hook to use the context
export const useETrustedReviews = () => {
  const context = useContext(ETrustedReviewsContext);
  if (context === undefined) {
    throw new Error('useETrustedReviews must be used within an ETrustedReviewProvider');
  }
  return context;
};

export default ETrustedReviewProvider;
